import React from 'react';
import './LoadingSpinner.css'; // Стили для спиннера
import { Spacer } from '../components/common/Decorations';

const PrevNextRow = ({ previousPage, nextPage }) => {
  return (
    <div>
        <Spacer height={50}/>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div style={{ flex: 1 }}>
            {previousPage && (
            <a href={previousPage.path} className="buttonqwe">
                <strong>&lt;&lt; {previousPage.title} &lt;&lt;</strong>
            </a>
            )}
        </div>
        <div>
            {nextPage && (
            <a href={nextPage.path} className="buttonqwe">
                <strong>&gt;&gt; {nextPage.title} &gt;&gt;</strong>
            </a>
            )}
        </div>
        </div>
        <Spacer height={50}/>
    </div>
  );
};

export default PrevNextRow;
